import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'
import './assets/styles/element-ui-reset.scss'
import './assets/styles/style.scss'
import axios from 'axios'
import './assets/icons' // icon
import './permission' // permission control
import {
  getDicts
} from "@/api/comm.js";
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  download,
  handleTree,
  ossDownload
} from "@/utils/ruoyi";
import Pagination from "@/components/Pagination";
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
import moment from 'moment'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// 引入echarts
import echarts from 'echarts'
Vue.component("Pagination", Pagination)
Vue.use(Element, {
  size: localStorage.getItem('size') || 'medium' // set element-ui default size
})
Vue.config.productionTip = false

// 全局方法挂载
Vue.prototype.$echarts = echarts
Vue.prototype.getDicts = getDicts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.ossDownload = ossDownload
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.moment = moment
moment.locale("zh-CN");
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')